export const SET_PRINT_UI_OPEN = 'PRINT_UI_OPEN'
export const SET_PRINT_UI_CLOSE = 'PRINT_UI_CLOSE'
export const SET_PRINT_SIZE = 'SET_PRINT_SIZE'
export const SET_PRINT_ORIENTATION = 'SET_PRINT_ORIENTATION'
export const SET_PRINT_MAP_CURRENT_SCALE = 'SET_PRINT_MAP_CURRENT_SCALE'
export const SET_PRINT_MAP_DPI = 'SET_PRINT_MAP_DPI'
export const SET_PRINT_SCALE = 'SET_PRINT_SCALE'
export const SET_PRINT_BLOB_URL = 'SET_PRINT_BLOB_URL'
export const SET_PRINT_TITLE = 'SET_PRINT_TITLE'
export const SET_PRINT_SIDE_PANEL = 'SET_PRINT_SIDE_PANEL'
export const SET_PRINT_INCLUDES_MAP = 'SET_PRINT_INCLUDES_MAP'
export const SET_PRINT_FIT_MAP = 'SET_PRINT_FIT_MAP'
export const SET_PRINT_STATS = 'SET_PRINT_STATS'
export const SET_PRINT_REPORT = 'SET_PRINT_REPORT'

export const setPrintSidePanel = printSidePanel => ({
  type: SET_PRINT_SIDE_PANEL,
  printSidePanel
})

export const setPrintIncludesMap = printIncludesMap => ({
  type: SET_PRINT_INCLUDES_MAP,
  printIncludesMap
})

export const setPrintFitMap = printFitMap => ({
  type: SET_PRINT_FIT_MAP,
  printFitMap
})

export const setPrintStats = printStats => ({
  type: SET_PRINT_STATS,
  printStats
})

export const setPrintTitle = printTitle => ({
  type: SET_PRINT_TITLE,
  printTitle
})

export const printUIOpen = () => ({
  type: SET_PRINT_UI_OPEN,
  printUIVisible: true
})

export const printUIClose = () => ({
  type: SET_PRINT_UI_CLOSE,
  printUIVisible: false
})

// @String printSize: like 'A4', 'A3', 'LETTER', etc.
// Full list here: https://github.com/diegomura/react-pdf/blob/master/src/utils/pageSizes.js
export const setPrintSize = printSize => ({
  type: SET_PRINT_SIZE,
  printSize
})

// @String printOrientation: 'portrait' or 'landscape'
// https://react-pdf.org/components#page
export const setPrintOrientation = printOrientation => ({
  type: SET_PRINT_ORIENTATION,
  printOrientation
})

// @String enum see above.
// This is to get around an issue with react-pdf fonts loading.
// https://github.com/diegomura/react-pdf/issues/310
export const setPrintBlobURL = printBlobURL => ({
  type: SET_PRINT_BLOB_URL,
  printBlobURL
})

export const setPrintMapCurrentScale = printMapCurrentScale => ({
  type: SET_PRINT_MAP_CURRENT_SCALE,
  printMapCurrentScale
})

export const setPrintMapDpi = printMapDpi => ({
  type: SET_PRINT_MAP_DPI,
  printMapDpi
})

export const setPrintScale = printScale => ({
  type: SET_PRINT_SCALE,
  printScale
})

export const setPrintReport = (layer, groupAttribute) => ({
  type: SET_PRINT_REPORT,
  printReport: { layer, groupAttribute }
})
